var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.09,124.53A131.37,131.37,0,1,0,387.46,255.9,131.36,131.36,0,0,0,256.09,124.53Zm0,216.64a85.27,85.27,0,1,1,85.27-85.27A85.24,85.24,0,0,1,256.09,341.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.56,1.61c-47.1-2.2-163.77-2.09-210.92,0C109.21,3.55,72.67,13.55,43.2,43-6,92.25.26,158.6.26,255.9c0,99.59-5.55,164.4,42.94,212.89,49.43,49.4,116.74,42.94,212.89,42.94,98.65,0,132.69.06,167.57-13.44,47.43-18.41,83.22-60.8,86.72-136.94,2.22-47.12,2.09-163.77,0-210.92C506.16,60.55,457.92,6.05,361.56,1.61Zm74.56,434.6c-32.28,32.28-77.05,29.4-180.65,29.4-106.67,0-149.44,1.58-180.65-29.72-35.95-35.78-29.44-93.23-29.44-180.33,0-117.87-12.1-202.75,106.2-208.81,27.18-1,35.18-1.28,103.59-1.28l1,.64c113.69,0,202.88-11.9,208.24,106.37,1.21,27,1.49,35.09,1.49,103.4,0,105.43,2,148.46-29.74,180.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 392.67,
    cy: 119.35,
    r: 30.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.7ba77c016260836cf80f59ef0d35ead6.svg";
export { ForwardRef as ReactComponent };